/* api.js */
import service from './request'
import qs from 'qs'
export const loginFun = data => {//登录
    return service({
        url: 'rescue_sale/user/usrLogin',
        method: 'post',
        data:qs.stringify(data)
    })
};
//首页
export const applyFor = data => {//
    return service({
        url: 'rescue_sale/user/application',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const homeTongji = data => {//统计
    return service({
        url: 'rescue_sale/sale/home',
        method: 'post',
        data:qs.stringify(data)
    })
};
//商户
export const getShopList = data => {//客户保障查询
    return service({
        url: 'rescue_sale/sale/record_search',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const importFile = data => {//客户保障上传
    return service({
        url: 'rescue_sale/order/import',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const topay = data => {//支付
    return service({
        url: 'rescue_sale/order/topay',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const submitOrder = data => {//客户保障提交
    return service({
        url: 'rescue_sale/order/submit_order',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const submitOrder2 = data => {//客户保障提交
  return service({
      url: 'rescue_sale/order/v2/submit_order',
      method: 'post',
      data:qs.stringify(data)
  })
};
/**
 * @description 调整订单或子单金额
 * @param {Object} data 请求参数
 * @returns {Promise}
 */
export const editOrder = data => {
    return service({
        url: 'rescue_sale/order/edit_order',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const delaypay = data => {//线下转账
    return service({
        url: 'rescue_sale/order/delaypay',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const searchBill = data => {//订单记录
    return service({
        url: 'rescue_sale/order/search',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listDd = data => {//订单记录
    return service({
        url: 'rescue_sale/order/list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listPreOrder = data => {//不记名核销订单列表
    return service({
        url: 'rescue_sale/order/list_pre_order',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listByState = data => {//财务已结 未结记录
    return service({
        url: 'rescue_sale/order/listByState',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listByDetail = data => {//订单记录详情
    return service({
        url: 'rescue_sale/order/detail',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const orderDetail = data => {//订单记录详情
  return service({
      url: 'rescue_sale/order/orderDetail',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const refund = data => {//综合退单
    return service({
        url: 'rescue_sale/sale/refund',
        method: 'post',
        data:qs.stringify(data)
    })
};

//设置
export const setInfo = data => {//机构设置
    return service({
        url: 'rescue_sale/user/setInfo',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getInfo = data => {//机构信息获取
    return service({
        url: 'rescue_sale/user/getInfo',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const addchannel = data => {//增加渠道
    return service({
        url: '1.0/rescue_sale/user/addchannel',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listchannel = data => {//渠道列表
    return service({
        url: 'rescue_sale/user/listchannel',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listchannelBySetter = data => {//渠道列表
    return service({
        url: 'rescue_sale/user/listchannelBySetter',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const delchannel = data => {//删除渠道
    return service({
        url: 'rescue_sale/user/delchannel',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const addsub = (data,pids) => {//增加员工
    return service({
        url: 'rescue_sale/user/addsub?'+pids,
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listsub = data => {//员工列表
    return service({
        url: 'rescue_sale/user/listsub',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listsubBySetter = data => {//员工列表
    return service({
        url: 'rescue_sale/user/listsubBySetter',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const delsub = data => {//员工删除
    return service({
        url: 'rescue_sale/user/delsub',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listPermission = data => {//授权
    return service({
        url: 'rescue_sale/user/listPermission',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const addPermission = (data,pids) => {//授权
    return service({
        url: 'rescue_sale/user/addPermission?'+pids,
        method: 'post',
        data:qs.stringify(data)
    })
};

//商品
export const productList = data => {//签约商品列表
    return service({
        url: 'rescue_sale/product/list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listProductByOrder = data => {//签约商品列表2
    return service({
        url: 'rescue_sale/product/listProductByOrder',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const statTotal = data => {//商品销售统计
    return service({
        url: 'rescue_sale/sale/stat_total',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const commodityDetail = data => {//签约产品详情
    return service({
        url: 'rescue_sale/product/detail',
        method: 'post',
        data:qs.stringify(data)
    })
};

export const refundListExit = data => {//退单记录
    return service({
        url: 'rescue_sale/sale/refund_list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const codeQuery = data => {//激活码有效期查询
    return service({
      //  entityCardSearch
        url: '/rescue_sale/sale/searchEntityCardByInfo',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const createGd = data => {//创建工单
    return service({
        url: 'rescue_sale/workticket/create',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const createGdList = data => {//工单列表
    return service({
        url: 'rescue_sale/workticket/list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const createGdClose = data => {//工单列表关闭
    return service({
        url: 'rescue_sale/workticket/close',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const replyGd = data => {//工单回复
    return service({
        url: 'rescue_sale/workticket/reply',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const batchNo = data => {//
    return service({
        url: 'rescue_sale/sale/batchNo',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getToken = data => {//某些机构可直接登录时
    return service({
        url: 'rescue_sale/user/getToken',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getFenzhi = data => {//获取分支机构
    return service({
        url: 'rescue_sale/user/listBranch',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const entityOrder = data => {//实体卡出单
    return service({
        url: 'rescue_sale/order/entity_order',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const updateAddress = data => {//实体卡增加地址
    return service({
        url: 'rescue_sale/order/update_address',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const addressList = data => {//实体卡地址列表
    return service({
        url: 'rescue_sale/order/address_list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const entityList = data => {//实体卡订单列表
    return service({
        url: 'rescue_sale/order/entity_list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const entityRefund = data => {//实体卡退单
    return service({
        url: 'rescue_sale/order/entity_refund',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const entityProductStat = data => {//实体卡销售统计
    return service({
        url: 'rescue_sale/order/entity_product_stat',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const entityDetailList = data => {//实体卡销售详情
    return service({
        url: 'rescue_sale/order/entity_detail_list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const entityDetail = data => {//实体卡销售详情
    return service({
        url: 'rescue_sale/order/entity_detail',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const deleteAddress = data => {//实体卡地址删除
    return service({
        url: 'rescue_sale/order/delete_address',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const activateCard = data => {//实体卡激活
    return service({
        url: 'rescue_sale/sale/activate',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const setSaleStatus = data => {//实体卡已售
    return service({
        url: 'rescue_sale/sale/setSaleStatus',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getMoneyOfTwo = data => {// 结算账单页面 订单金额&分成金额
    return service({
        url: 'rescue_sale/financial/sumCutAmount',
        method: 'post',
        data:qs.stringify(data)
    })
};

//结算申请
export const settle = data => {// 申请结算
    return service({
        url: 'rescue_sale/financial/settle',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const settleStat = data => {// 统计 结算总金额
    return service({
        url: 'rescue_sale/financial/settle_stat',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const settlementList = data => {// 申请结算列表
    return service({
        url: 'rescue_sale/financial/settlement_list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const issue = data => {// 申请发票
    return service({
        url: 'rescue_sale/financial/invoice/issue',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const issue2 = data => {// 申请发票2
    return service({
        url: 'rescue_sale/financial/invoice/issue2',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const invoiceList = data => {// 申请发票列表
    return service({
        url: 'rescue_sale/financial/invoice/ilst',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const settleOrderlist = data => {// 申请发票列表
    return service({
        url: 'rescue_sale/financial/settle_orderlist',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getPCActivateSign = data => {// 激活签名
    return service({
        url: '1.0/equitycard/getPCActivateSign',
        method: 'post',
        data:qs.stringify(data)
    })
};

//门店
export const travelChannelList = data => {// 分店列表
    return service({
        url: 'rescue_sale/sale/travel_channel_list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const approveTravel = data => {// 分店同意开通
    return service({
        url: 'rescue_sale/sale/approve_travel',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const rejectTravel = data => {// 分店拒绝开通
    return service({
        url: 'rescue_sale/sale/reject_travel',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const cancelContractTravel = data => {// 分店解约
    return service({
        url: 'rescue_sale/user/cancel_contract_travel',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listCantractProduct = data => {// 分店签约列表
    return service({
        url: 'rescue_sale/user/listCantractProduct',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const sign4Travel = data => {// 分店签约
    return service({
        url: 'rescue_sale/user/sign4travel',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const statBillingByTravel = data => {// 分店统计
    return service({
        url: 'rescue_sale/user/statBillingByTravel',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const statBillingByProduct = data => {// 门店按清单统计
    return service({
        url: 'rescue_sale/user/statBillingByProduct',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const settDefaultPrice = data => {// 门店设置默认价格
    return service({
        url: 'rescue_sale/user/settDefaultPrice',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const fictPay = data => {// 门店虚拟卡支付
    return service({
        url: 'rescue_sale/order/fictpay',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const resetApproving = data => {// 门店虚拟卡支付
    return service({
        url: 'rescue_sale/user/reset_approving',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const ration = data => {// 发票额度查询
    return service({
        url: 'rescue_sale/financial/invoice/ration',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const distNews = data => {// 发票额度查询
    return service({
        url: '1.0/news/dist_news?subcategory=3',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const appendInvoice = data => {// 上传发票
    return service({
        url: 'rescue_sale/financial/append_invoice',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listInvoiceBillDetail = data => {// 可开发票列表
    return service({
        url: 'rescue_sale/financial/list_invoice_bill_detail',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getInvoiceDetail = data => {// 可开发票列表详情
    return service({
        url: 'rescue_sale/order/getInvoiceDetail',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const downloadPdf = data => {// 可开发票列表详情
    return service({
        url: '1.0/rescue_sale/sale/download_pdf',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const purchasedCards = data => {// 礼品卡
    return service({
        url: 'rescue_sale/order/purchasedcards',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const purchasedcardsStat = data => {// 礼品卡
    return service({
        url: 'rescue_sale/order/purchasedcards_stat',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const invoiceDetail = data => {// 获取发票信息
    return service({
        url: 'rescue_sale/financial/invoice/detail',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const salechangeBillInfo = data => {// 保障人更改
  return service({
      url: 'rescue_sale/sale/changeBillInfo',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const salecancelBillInfo = data => {// 批减
  return service({
      url: 'rescue_sale/sale/cancelBillInfo',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const orderexportOrderList = data => {// 订单记录导出
  return service({
      url: 'rescue_sale/order/exportOrderList',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const ordergetChannelBillDetailList = data => {// 订单详情页面
  return service({
      url: 'rescue_sale/order/getChannelBillDetailList',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const userchannellist = data => {// 订单详情页面
  return service({
      url: 'rescue_sale/user/channel-list',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const orderbillDetail = data => {// 订单详情页面
  return service({
      url: 'rescue_sale/order/billDetail',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const prestoreaccount = data => {// 分销预存接口
  return service({
      url: 'rescue_sale/prestore/account',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const prestorerecords = data => {// 分销预存列表
  return service({
      url: 'rescue_sale/prestore/records',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const prestoreupdateBalance = data => {// 充值提现
  return service({
      url: 'rescue_sale/prestore/refund',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const prestoretopay = data => {// 分销系统二维码支付
  return service({
      url: 'rescue_sale/prestore/topay',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const prestoreto_card_pay = data => {// 分销系统对公转账
  return service({
      url: 'rescue_sale/prestore/to_card_pay',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const prestoredetail = data => {// 购买完成后回调接口
  return service({
      url: 'rescue_sale/prestore/detail',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const prestoreset_recharge_type = data => {// 选择账户类型
  return service({
      url: 'rescue_sale/prestore/set_recharge_type',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const ordercheck_order = data => {// 校验
  return service({
      url: 'rescue_sale/order/check_order',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const wechat_prestore_order = data => {// 校验
  return service({
      url: 'rescue_sale/order/submit_prestore_order',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const wechat_prestore_orderv2 = data => {// 校验
  return service({
      url: 'rescue_sale/order/v2/submit_prestore_order',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const rescue_saleprestoreaccount = data => {// 手机号设置
  return service({
      url: 'rescue_sale/prestore/edit-remind-account',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const listProductConfig = data => {// 产品筛选条件
  return service({
      url: 'rescue_sale/product/listProductConfig',
      method: 'post',
      data:qs.stringify(data)
  })
};
// 学习中心
export const news_list = data => {// 文章列表
  return service({
    url: '/1.0/news/news-list?category=' + data.category + '&start=' + data.start + '&type=' + data.type + '&count=' + data.count,
    method: 'get'
  })
};
export const news_detail = data => {// 文章详情
  return service({
    url: '/1.0/news/news-info?id=' + data.id,
    method: 'get'
  })
}
export const userchange_pwd = data => {// 修改密码
  return service({
      url: 'rescue_sale/user/change_pwd',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const systemProductInfo = data => {// 新清单详情
  return service({
      url: 'rescue_sale/v2/product/systemProductInfo',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const revoke_invoice = data => {// 文章详情
  return service({
    url: 'rescue_sale/financial/invoice/revoke_invoice?iid=' + data.id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/axios/api.js